/**
 * IMPORTANT
 * This file is exclusively for Vue 2 usage.
 *
 *
 * Vue2 file: Current FIle
 * Vue3 file: vue3/src/Events/EpsilonTaggingManager.js
 *
 * If you are making changes  in this file,
 * please make sure to make the same changes in the Vue3 file as well.
 *
 * Note: This file is marked for future removal.
 *
 * For further details, please contact Leela.
 */

import { EpsilonVolvoTagging } from './OEMTagManagers/EpsilonVolvoTagging';

export class EpsilonTagManagerContainer {
  constructor() {
    this.make = window.make;
  }

  static getDealerObject() {
    let object = '';
    if (
      window.enableOEMProgram &&
      window.enableWebsiteTagging &&
      window.enableEpsilonTags &&
      window.oemProgramName === 'Volvo'
    ) {
      return new EpsilonVolvoTagging();
    }

    return object;
  }
}
